import { IFinalValues } from '@Src/types/dashboard-interface'
import React from 'react'
import "../../LifeCareerPdf.scss"

const Test2Pdf = (props: { finalValues: IFinalValues | undefined,name:string  }) => {
    return (
        <div className='test-2' style={{ fontFamily: 'Arial, sans-serif', padding: '0.5rem 2rem', width: "1100px", }}>
            <div className='important-current-career page-class'>
                <h2 style={{ marginTop: '15px', fontSize: '21px', fontWeight: '700' }} >{props.name} - Your Most Important Current/Most Recent Career Values</h2>
                <ul style={{ marginLeft: '8px' }}>
                    {props.finalValues?.t2.map((value, index) => (
                        <li style={{ marginTop: '15px', fontSize: '21px', fontWeight: '600' }} key={index}>{index + 1} - {value.option_value}</li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default Test2Pdf